import { createAction } from '@reduxjs/toolkit'
import { ConnectionType } from 'connection/types'
import { TradeType } from 'store/market/types'
import { MuiThemeType } from 'styles/Themes'
import {
  MandatoryToastType,
  PreferenceType,
  TifType,
  EFavoriteAssetsElements,
} from './types'

export const updateTheme = createAction<MuiThemeType>('settings/updateTheme')
export const updateConnectorName = createAction<{
  connectorName: ConnectionType | undefined
}>('settings/updateConnectorName')
export const updateShowPortfolio = createAction<boolean>(
  'settings/updateShowPortfolio',
)
export const updateSaveToken = createAction<boolean>('settings/updateSaveToken')
export const updateShowMandatoryToast = createAction<MandatoryToastType>(
  'settings/updateShowMandatoryToast',
)
export const updateUserLeverage = createAction<number>(
  'settings/updateUserLeverage',
)
export const updatePlaceOrderTIFAction = createAction<{
  tradeType: TradeType
  tif: TifType
}>('settings/updatePlaceOrderTIFAction')
export const updatePreferences = createAction<PreferenceType>(
  'settings/updatePreferences',
)
export const updatePreference = createAction<{
  type: keyof PreferenceType
  value: boolean
}>('settings/updatePreference')

export const updateFavoriteAssetsElements = createAction<{
  type: string
  value: EFavoriteAssetsElements
}>('settings/updateFavoriteAssetsElements')
